import { useMemo } from 'react';
import { t, useLocale } from './index';
import type { TranslationKey } from './index';

export function useTranslation() {
  const locale = useLocale();
  return useMemo(
    () => (key: TranslationKey, params?: Record<string, string | number>) => t(key, params),
    [locale],
  );
}
